import qrcodesection from '@/components/qrcode2';
export default {
  name: 'clockqr',
  meta: {
    title: '获取二维码'
  },
  components: {
    qrcodesection
  },
  data() {
    return {
      query: '',
      url: ''
    };
  },
  mounted() {
    this.query = this.$route.query;
    this.url = `${location.origin}${location.pathname}#/clockIn?fid=${this.query.fid}&formId=${this.query.formId}&formUserId=${this.query.formUserId}`;
  },
  watch: {},
  methods: {}
};